import api from './api';

export const ppidContentService = {
    getContentsBySlug: async (slug) => {
        try {
            const response = await api.get(`/ppid-contents/by-slug/${slug}`);
            return { success: true, data: response.data };
        } catch (error) {
            console.error('Error fetching contents by slug:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil data'
            };
        }
    },

    // Get all contents (admin)
    getContents: async (params = {}) => {
        try {
            const response = await api.get('/ppid-contents/public', { params });

            // Cek struktur response
            if (response.data && response.data.success === false) {
                return {
                    success: false,
                    message: response.data.message || 'Gagal mengambil data'
                };
            }

            return {
                success: true,
                data: response.data
            };
        } catch (error) {
            console.error('Error fetching contents:', error);

            // Tampilkan error detail
            let errorMessage = 'Gagal mengambil data konten';
            if (error.response) {
                // Server meresponse dengan error
                errorMessage = error.response.data?.message ||
                    error.response.data?.error ||
                    `Error ${error.response.status}: ${error.response.statusText}`;
            } else if (error.request) {
                // Request dikirim tapi tidak ada response
                errorMessage = 'Server tidak meresponse, periksa koneksi';
            }

            return {
                success: false,
                message: errorMessage,
                error: error
            };
        }
    },

    // Get contents by menu slug (public)
    getByMenuSlug: async (menuSlug) => {
        try {
            const response = await api.get(`/ppid-contents/menu/${menuSlug}`);
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil konten'
            };
        }
    },

    // Create content
    createContent: async (formData) => {
        try {
            const response = await api.post('/ppid-contents', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal membuat konten'
            };
        }
    },

    // Update content
    updateContent: async (id, formData) => {
        try {
            const response = await api.put(`/ppid-contents/${id}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengupdate konten'
            };
        }
    },

    // Delete content
    deleteContent: async (id) => {
        try {
            const response = await api.delete(`/ppid-contents/${id}`);
            return { success: true, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal menghapus konten'
            };
        }
    },

    // Update status
    updateStatus: async (id, status) => {
        try {
            const response = await api.post(`/ppid-contents/${id}/status`, { status });
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengubah status'
            };
        }
    },

    // Get statistics
    getStatistics: async () => {
        try {
            const response = await api.get('/ppid-statistics');
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil statistik'
            };
        }
    },

    // Download file
    getDownloadUrl: (id) => `${api.defaults.baseURL}/ppid-contents/${id}/download`
};